import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form
} from "react-bootstrap";

import axios from "axios";

import {
  useNavigate
} from "react-router-dom";

import { MyApi } from "../MyApi";

const slotsData = [

  { time: "6:00 AM - 7:00 AM", price: 599 },
  { time: "7:00 AM - 8:00 AM", price: 599 },
  { time: "8:00 AM - 9:00 AM", price: 599 },
  { time: "9:00 AM - 10:00 AM", price: 599 },
  { time: "10:00 AM - 11:00 AM", price: 599 },
  { time: "11:00 AM - 12:00 PM", price: 599 },
  { time: "12:00 PM - 1:00 PM", price: 599 },
  { time: "1:00 PM - 2:00 PM", price: 599 },
  { time: "2:00 PM - 3:00 PM", price: 599 },
  { time: "3:00 PM - 4:00 PM", price: 599 },
  { time: "4:00 PM - 5:00 PM", price: 599 },

  { time: "5:00 PM - 6:00 PM", price: 799 },
  { time: "6:00 PM - 7:00 PM", price: 799 },
  { time: "7:00 PM - 8:00 PM", price: 799 },
  { time: "8:00 PM - 9:00 PM", price: 799 },
  { time: "9:00 PM - 10:00 PM", price: 799 },
  { time: "10:00 PM - 11:00 PM", price: 799 },
  { time: "11:00 PM - 12:00 AM", price: 799 }

];

export default function TurfBooking() {

  const navigate = useNavigate();

  const [selectedSlots, setSelectedSlots] = useState([]);

  const [date, setDate] = useState("");

  const [customer, setCustomer] = useState({
    name: "",
    mobile: "",
    email: ""
  });

  const [captcha, setCaptcha] = useState({
    num1: 0,
    num2: 0
  });

  const [captchaInput, setCaptchaInput] = useState("");

  const [captchaError, setCaptchaError] = useState("");

  // Generate Captcha
  const generateCaptcha = () => {

    const n1 = Math.floor(Math.random() * 10);

    const n2 = Math.floor(Math.random() * 10);

    setCaptcha({
      num1: n1,
      num2: n2
    });
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  // Check Past Slot
  const isPastSlot = (slotTime) => {

    if (!date) return false;

    const today = new Date().toISOString().split("T")[0];

    if (date !== today) return false;

    const now = new Date();

    const startTime = slotTime.split(" - ")[0];

    const [time, modifier] = startTime.split(" ");

    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    }

    if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    const slotDateTime = new Date();

    slotDateTime.setHours(hours, minutes, 0);

    return slotDateTime < now;
  };

  // Format Date
  const formatDate = (d) => {

    const dt = new Date(d);

    return dt.toLocaleDateString("en-GB");
  };

  // Toggle Slot
  const toggleSlot = (slot) => {

    if (!date) {

      alert("Please select date first");

      return;
    }

    if (isPastSlot(slot.time)) {

      alert("This slot time has already passed");

      return;
    }

    const exists = selectedSlots.find(
      (s) => s.time === slot.time && s.date === date
    );

    if (exists) {

      setSelectedSlots(
        selectedSlots.filter(
          (s) => !(s.time === slot.time && s.date === date)
        )
      );

    } else {

      setSelectedSlots([
        ...selectedSlots,
        {
          ...slot,
          date
        }
      ]);
    }
  };

  // Total
  const total = selectedSlots.reduce(
    (sum, s) => sum + s.price,
    0
  );

  // Customer Change
  const handleCustomerChange = (e) => {

    setCustomer({
      ...customer,
      [e.target.name]: e.target.value
    });
  };

  // Validate Captcha
  const validateCaptcha = () => {

    if (
      parseInt(captchaInput) !==
      captcha.num1 + captcha.num2
    ) {

      setCaptchaError("Wrong captcha");

      generateCaptcha();

      setCaptchaInput("");

      return false;
    }

    setCaptchaError("");

    return true;
  };

  // Submit Form
  const handleSubmit = async () => {

    if (
      !customer.name ||
      !customer.mobile ||
      !customer.email
    ) {

      alert("Please fill all customer details");

      return;
    }

    if (selectedSlots.length === 0) {

      alert("Please select at least one slot");

      return;
    }

    if (!validateCaptcha()) return;

    const bookingData = {
      customer,
      selectedSlots,
      total
    };

    try {

      const response = await axios.post(
        MyApi.BASE_URL + MyApi.TURF_BOOKING,
        bookingData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: MyApi.SECRET_KEY
          }
        }
      );

      if (response.data.status) {

        // Redirect With Data
        navigate("/payment", {
          state: bookingData
        });

      } else {

        alert(response.data.message);

      }

    } catch (error) {

      console.log(error);

      console.log(error.response);

      alert("Server Error");
    }
  };

  return (
    <Container className="mt-4 py-5">

      <h3 className="mb-4">
        🏏 Cricket Box Turf - Slot Booking
      </h3>

      {/* Date */}
      <Form.Group className="mb-3">

        <Form.Label>Select Date</Form.Label>

        <Form.Control
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          min={new Date().toISOString().split("T")[0]}
        />

      </Form.Group>

      {/* Slots */}
      <Row>

        {slotsData.map((slot, index) => {

          const isSelected = selectedSlots.find(
            (s) =>
              s.time === slot.time &&
              s.date === date
          );

          return (

            <Col md={3} className="mb-2" key={index}>

              <Button
                className="w-100"
                variant={
                  isSelected
                    ? "danger"
                    : "success"
                }
                disabled={isPastSlot(slot.time)}
                onClick={() => toggleSlot(slot)}
              >
                {slot.time}
                <br />
                ₹{slot.price}
              </Button>

            </Col>
          );
        })}

      </Row>

      {/* Selected Slots */}
      <div className="mt-4">

        <h5>Selected Slots</h5>

        {selectedSlots.length === 0 ? (

          <p>No slots selected yet</p>

        ) : (

          <ul
            style={{
              listStyle: "none",
              padding: 0
            }}
          >

            {selectedSlots.map((s, i) => (

              <li
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "8px",
                  background: "#f5f5f5",
                  padding: "10px",
                  borderRadius: "6px"
                }}
              >

                <span>
                  📅 {formatDate(s.date)}
                  {" | "}
                  ⏰ {s.time}
                  {" | "}
                  ₹{s.price}
                </span>

                <span
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontWeight: "bold"
                  }}
                  onClick={() =>
                    setSelectedSlots(
                      selectedSlots.filter(
                        (item) =>
                          !(
                            item.time === s.time &&
                            item.date === s.date
                          )
                      )
                    )
                  }
                >
                  ❌
                </span>

              </li>

            ))}

          </ul>
        )}

      </div>

      <h4 className="mt-3">
        Total: ₹{total}
      </h4>

      <hr />

      {/* Customer Form */}
      <h5>Customer Details</h5>

      <Row>

        <Col md={4}>

          <Form.Control
            type="text"
            name="name"
            placeholder="Full Name *"
            value={customer.name}
            onChange={handleCustomerChange}
            className="mb-2"
          />

        </Col>

        <Col md={4}>

          <Form.Control
            type="text"
            name="mobile"
            placeholder="Mobile Number *"
            value={customer.mobile}
            onChange={handleCustomerChange}
            className="mb-2"
          />

        </Col>

        <Col md={4}>

          <Form.Control
            type="email"
            name="email"
            placeholder="Email Address *"
            value={customer.email}
            onChange={handleCustomerChange}
            className="mb-2"
          />

        </Col>

      </Row>

      {/* Captcha */}
      <Row className="mt-3">

        <Col md={6}>

          <div className="d-flex align-items-center">

            <b className="me-2">
              {captcha.num1} + {captcha.num2} = ?
            </b>

            <Form.Control
              value={captchaInput}
              onChange={(e) =>
                setCaptchaInput(e.target.value)
              }
              placeholder="Enter Captcha"
            />

            <Button
              variant="secondary"
              className="ms-2"
              onClick={generateCaptcha}
            >
              ↻
            </Button>

          </div>

          {captchaError && (

            <small style={{ color: "red" }}>
              {captchaError}
            </small>

          )}

        </Col>

        <Col md={6}>

          <Button
            variant="primary"
            className="w-100 mt-2"
            onClick={handleSubmit}
          >
            Proceed To Payment
          </Button>

        </Col>

      </Row>

    </Container>
  );
}